// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import domain from '@/api/api_url.js';
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import axios from 'axios';
import VueCookies from 'vue-cookies'
import '@/styles/index.css' // global css
import Vconsole from 'vconsole'
//new Vconsole()
Vue.use(VueCookies)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.prototype.axios = axios;
axios.defaults.baseURL = domain.domain
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')&&localStorage.getItem('Authorization')!='undefined') {
      config.headers.Authorization = localStorage.getItem('Authorization');
      config.headers['Content-Type'] = 'application/json'
    }else{
      config.headers['Content-Type'] = 'application/json'
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js